import AccessibilityNewSvg from '@uswds/uswds/img/usa-icons/accessibility_new.svg?svgr'
import AccessibleForwardSvg from '@uswds/uswds/img/usa-icons/accessible_forward.svg?svgr'
import AccountBalanceSvg from '@uswds/uswds/img/usa-icons/account_balance.svg?svgr'
import AccountBoxSvg from '@uswds/uswds/img/usa-icons/account_box.svg?svgr'
import AccountCircleSvg from '@uswds/uswds/img/usa-icons/account_circle.svg?svgr'
import AddSvg from '@uswds/uswds/img/usa-icons/add.svg?svgr'
import AddCircleSvg from '@uswds/uswds/img/usa-icons/add_circle.svg?svgr'
import AddCircleOutlineSvg from '@uswds/uswds/img/usa-icons/add_circle_outline.svg?svgr'
import AlarmSvg from '@uswds/uswds/img/usa-icons/alarm.svg?svgr'
import AlternateEmailSvg from '@uswds/uswds/img/usa-icons/alternate_email.svg?svgr'
import AnnouncementSvg from '@uswds/uswds/img/usa-icons/announcement.svg?svgr'
import ArrowBackSvg from '@uswds/uswds/img/usa-icons/arrow_back.svg?svgr'
import ArrowDownwardSvg from '@uswds/uswds/img/usa-icons/arrow_downward.svg?svgr'
import ArrowDropDownSvg from '@uswds/uswds/img/usa-icons/arrow_drop_down.svg?svgr'
import ArrowDropUpSvg from '@uswds/uswds/img/usa-icons/arrow_drop_up.svg?svgr'
import ArrowForwardSvg from '@uswds/uswds/img/usa-icons/arrow_forward.svg?svgr'
import ArrowUpwardSvg from '@uswds/uswds/img/usa-icons/arrow_upward.svg?svgr'
import ApiSvg from '@uswds/uswds/img/usa-icons/api.svg?svgr'
import AssessmentSvg from '@uswds/uswds/img/usa-icons/assessment.svg?svgr'
import AttachFileSvg from '@uswds/uswds/img/usa-icons/attach_file.svg?svgr'
import AttachMoneySvg from '@uswds/uswds/img/usa-icons/attach_money.svg?svgr'
import AutorenewSvg from '@uswds/uswds/img/usa-icons/autorenew.svg?svgr'
import BackpackSvg from '@uswds/uswds/img/usa-icons/backpack.svg?svgr'
import BathtubSvg from '@uswds/uswds/img/usa-icons/bathtub.svg?svgr'
import BeddingSvg from '@uswds/uswds/img/usa-icons/bedding.svg?svgr'
import BookmarkSvg from '@uswds/uswds/img/usa-icons/bookmark.svg?svgr'
import BugReportSvg from '@uswds/uswds/img/usa-icons/bug_report.svg?svgr'
import BuildSvg from '@uswds/uswds/img/usa-icons/build.svg?svgr'
import CalendarTodaySvg from '@uswds/uswds/img/usa-icons/calendar_today.svg?svgr'
import CampaignSvg from '@uswds/uswds/img/usa-icons/campaign.svg?svgr'
import CampingSvg from '@uswds/uswds/img/usa-icons/camping.svg?svgr'
import CancelSvg from '@uswds/uswds/img/usa-icons/cancel.svg?svgr'
import ChatSvg from '@uswds/uswds/img/usa-icons/chat.svg?svgr'
import CheckSvg from '@uswds/uswds/img/usa-icons/check.svg?svgr'
import CheckBoxOutlineBlankSvg from '@uswds/uswds/img/usa-icons/check_box_outline_blank.svg?svgr'
import CheckCircleSvg from '@uswds/uswds/img/usa-icons/check_circle.svg?svgr'
import CheckCircleOutlineSvg from '@uswds/uswds/img/usa-icons/check_circle_outline.svg?svgr'
import CheckroomSvg from '@uswds/uswds/img/usa-icons/checkroom.svg?svgr'
import CleanHandsSvg from '@uswds/uswds/img/usa-icons/clean_hands.svg?svgr'
import ClothesSvg from '@uswds/uswds/img/usa-icons/clothes.svg?svgr'
import CloseSvg from '@uswds/uswds/img/usa-icons/close.svg?svgr'
import ClosedCaptionSvg from '@uswds/uswds/img/usa-icons/closed_caption.svg?svgr'
import CloudSvg from '@uswds/uswds/img/usa-icons/cloud.svg?svgr'
import CodeSvg from '@uswds/uswds/img/usa-icons/code.svg?svgr'
import CommentSvg from '@uswds/uswds/img/usa-icons/comment.svg?svgr'
import ConnectWithoutContactSvg from '@uswds/uswds/img/usa-icons/connect_without_contact.svg?svgr'
import ConstructionSvg from '@uswds/uswds/img/usa-icons/construction.svg?svgr'
import ConstructionWorkerSvg from '@uswds/uswds/img/usa-icons/construction_worker.svg?svgr'
import ContactPageSvg from '@uswds/uswds/img/usa-icons/contact_page.svg?svgr'
import ContentCopySvg from '@uswds/uswds/img/usa-icons/content_copy.svg?svgr'
import CoronavirusSvg from '@uswds/uswds/img/usa-icons/coronavirus.svg?svgr'
import CreditCardSvg from '@uswds/uswds/img/usa-icons/credit_card.svg?svgr'
import DeckSvg from '@uswds/uswds/img/usa-icons/deck.svg?svgr'
import DeleteSvg from '@uswds/uswds/img/usa-icons/delete.svg?svgr'
import DeviceThermostatSvg from '@uswds/uswds/img/usa-icons/device_thermostat.svg?svgr'
import DirectionsSvg from '@uswds/uswds/img/usa-icons/directions.svg?svgr'
import DirectionsBikeSvg from '@uswds/uswds/img/usa-icons/directions_bike.svg?svgr'
import DirectionsBusSvg from '@uswds/uswds/img/usa-icons/directions_bus.svg?svgr'
import DirectionsCarSvg from '@uswds/uswds/img/usa-icons/directions_car.svg?svgr'
import DirectionsWalkSvg from '@uswds/uswds/img/usa-icons/directions_walk.svg?svgr'
import DoNotDisturbSvg from '@uswds/uswds/img/usa-icons/do_not_disturb.svg?svgr'
import DoNotTouchSvg from '@uswds/uswds/img/usa-icons/do_not_touch.svg?svgr'
import DragHandleSvg from '@uswds/uswds/img/usa-icons/drag_handle.svg?svgr'
import EcoSvg from '@uswds/uswds/img/usa-icons/eco.svg?svgr'
import EditSvg from '@uswds/uswds/img/usa-icons/edit.svg?svgr'
import ElectricalServicesSvg from '@uswds/uswds/img/usa-icons/electrical_services.svg?svgr'
import EmojiEventsSvg from '@uswds/uswds/img/usa-icons/emoji_events.svg?svgr'
import ErrorSvg from '@uswds/uswds/img/usa-icons/error.svg?svgr'
import ErrorOutlineSvg from '@uswds/uswds/img/usa-icons/error_outline.svg?svgr'
import EventSvg from '@uswds/uswds/img/usa-icons/event.svg?svgr'
import ExpandLessSvg from '@uswds/uswds/img/usa-icons/expand_less.svg?svgr'
import ExpandMoreSvg from '@uswds/uswds/img/usa-icons/expand_more.svg?svgr'
import FacebookSvg from '@uswds/uswds/img/usa-icons/facebook.svg?svgr'
import FastForwardSvg from '@uswds/uswds/img/usa-icons/fast_forward.svg?svgr'
import FastRewindSvg from '@uswds/uswds/img/usa-icons/fast_rewind.svg?svgr'
import FavoriteSvg from '@uswds/uswds/img/usa-icons/favorite.svg?svgr'
import FavoriteBorderSvg from '@uswds/uswds/img/usa-icons/favorite_border.svg?svgr'
import FaxSvg from '@uswds/uswds/img/usa-icons/fax.svg?svgr'
import FileDownloadSvg from '@uswds/uswds/img/usa-icons/file_download.svg?svgr'
import FilePresentSvg from '@uswds/uswds/img/usa-icons/file_present.svg?svgr'
import FileUploadSvg from '@uswds/uswds/img/usa-icons/file_upload.svg?svgr'
import FilterAltSvg from '@uswds/uswds/img/usa-icons/filter_alt.svg?svgr'
import FilterListSvg from '@uswds/uswds/img/usa-icons/filter_list.svg?svgr'
import FingerprintSvg from '@uswds/uswds/img/usa-icons/fingerprint.svg?svgr'
import FirstPageSvg from '@uswds/uswds/img/usa-icons/first_page.svg?svgr'
import FlagSvg from '@uswds/uswds/img/usa-icons/flag.svg?svgr'
import FlickrSvg from '@uswds/uswds/img/usa-icons/flickr.svg?svgr'
import FlightSvg from '@uswds/uswds/img/usa-icons/flight.svg?svgr'
import FloodingSvg from '@uswds/uswds/img/usa-icons/flooding.svg?svgr'
import FolderSvg from '@uswds/uswds/img/usa-icons/folder.svg?svgr'
import FolderOpenSvg from '@uswds/uswds/img/usa-icons/folder_open.svg?svgr'
import FormatQuoteSvg from '@uswds/uswds/img/usa-icons/format_quote.svg?svgr'
import FormatSizeSvg from '@uswds/uswds/img/usa-icons/format_size.svg?svgr'
import ForumSvg from '@uswds/uswds/img/usa-icons/forum.svg?svgr'
import GithubSvg from '@uswds/uswds/img/usa-icons/github.svg?svgr'
import GridViewSvg from '@uswds/uswds/img/usa-icons/grid_view.svg?svgr'
import GroupAddSvg from '@uswds/uswds/img/usa-icons/group_add.svg?svgr'
import GroupsSvg from '@uswds/uswds/img/usa-icons/groups.svg?svgr'
import HearingSvg from '@uswds/uswds/img/usa-icons/hearing.svg?svgr'
import HelpSvg from '@uswds/uswds/img/usa-icons/help.svg?svgr'
import HelpOutlineSvg from '@uswds/uswds/img/usa-icons/help_outline.svg?svgr'
import HighlightOffSvg from '@uswds/uswds/img/usa-icons/highlight_off.svg?svgr'
import HistorySvg from '@uswds/uswds/img/usa-icons/history.svg?svgr'
import HomeSvg from '@uswds/uswds/img/usa-icons/home.svg?svgr'
import HospitalSvg from '@uswds/uswds/img/usa-icons/hospital.svg?svgr'
import HotelSvg from '@uswds/uswds/img/usa-icons/hotel.svg?svgr'
import HourglassEmptySvg from '@uswds/uswds/img/usa-icons/hourglass_empty.svg?svgr'
import HurricaneSvg from '@uswds/uswds/img/usa-icons/hurricane.svg?svgr'
import IdentificationSvg from '@uswds/uswds/img/usa-icons/identification.svg?svgr'
import ImageSvg from '@uswds/uswds/img/usa-icons/image.svg?svgr'
import InfoSvg from '@uswds/uswds/img/usa-icons/info.svg?svgr'
import InfoOutlineSvg from '@uswds/uswds/img/usa-icons/info_outline.svg?svgr'
import InsightsSvg from '@uswds/uswds/img/usa-icons/insights.svg?svgr'
import InstagramSvg from '@uswds/uswds/img/usa-icons/instagram.svg?svgr'
import KeyboardSvg from '@uswds/uswds/img/usa-icons/keyboard.svg?svgr'
import LabelSvg from '@uswds/uswds/img/usa-icons/label.svg?svgr'
import LanguageSvg from '@uswds/uswds/img/usa-icons/language.svg?svgr'
import LastPageSvg from '@uswds/uswds/img/usa-icons/last_page.svg?svgr'
import LaunchSvg from '@uswds/uswds/img/usa-icons/launch.svg?svgr'
import LightbulbSvg from '@uswds/uswds/img/usa-icons/lightbulb.svg?svgr'
import LightbulbOutlineSvg from '@uswds/uswds/img/usa-icons/lightbulb_outline.svg?svgr'
import LinkedInSvg from '@uswds/uswds/img/usa-icons/linkedin.svg?svgr'
import LinkSvg from '@uswds/uswds/img/usa-icons/link.svg?svgr'
import LinkOffSvg from '@uswds/uswds/img/usa-icons/link_off.svg?svgr'
import ListSvg from '@uswds/uswds/img/usa-icons/list.svg?svgr'
import LocalCafeSvg from '@uswds/uswds/img/usa-icons/local_cafe.svg?svgr'
import LocalFireDepartmentSvg from '@uswds/uswds/img/usa-icons/local_fire_department.svg?svgr'
import LocalGasStationSvg from '@uswds/uswds/img/usa-icons/local_gas_station.svg?svgr'
import LocalGroceryStoreSvg from '@uswds/uswds/img/usa-icons/local_grocery_store.svg?svgr'
import LocalHospitalSvg from '@uswds/uswds/img/usa-icons/local_hospital.svg?svgr'
import LocalLaundryServiceSvg from '@uswds/uswds/img/usa-icons/local_laundry_service.svg?svgr'
import LocalLibrarySvg from '@uswds/uswds/img/usa-icons/local_library.svg?svgr'
import LocalOfferSvg from '@uswds/uswds/img/usa-icons/local_offer.svg?svgr'
import LocalParkingSvg from '@uswds/uswds/img/usa-icons/local_parking.svg?svgr'
import LocalPharmacySvg from '@uswds/uswds/img/usa-icons/local_pharmacy.svg?svgr'
import LocalPoliceSvg from '@uswds/uswds/img/usa-icons/local_police.svg?svgr'
import LocalTaxiSvg from '@uswds/uswds/img/usa-icons/local_taxi.svg?svgr'
import LocationCitySvg from '@uswds/uswds/img/usa-icons/location_city.svg?svgr'
import LocationOnSvg from '@uswds/uswds/img/usa-icons/location_on.svg?svgr'
import LockSvg from '@uswds/uswds/img/usa-icons/lock.svg?svgr'
import LockOpenSvg from '@uswds/uswds/img/usa-icons/lock_open.svg?svgr'
import LockOutlineSvg from '@uswds/uswds/img/usa-icons/lock_outline.svg?svgr'
import LoginSvg from '@uswds/uswds/img/usa-icons/login.svg?svgr'
import LogoutSvg from '@uswds/uswds/img/usa-icons/logout.svg?svgr'
import LoopSvg from '@uswds/uswds/img/usa-icons/loop.svg?svgr'
import MailSvg from '@uswds/uswds/img/usa-icons/mail.svg?svgr'
import MailOutlineSvg from '@uswds/uswds/img/usa-icons/mail_outline.svg?svgr'
import MapSvg from '@uswds/uswds/img/usa-icons/map.svg?svgr'
import MasksSvg from '@uswds/uswds/img/usa-icons/masks.svg?svgr'
import MedicalServicesSvg from '@uswds/uswds/img/usa-icons/medical_services.svg?svgr'
import MenuSvg from '@uswds/uswds/img/usa-icons/menu.svg?svgr'
import MilitaryTechSvg from '@uswds/uswds/img/usa-icons/military_tech.svg?svgr'
import MoreHorizSvg from '@uswds/uswds/img/usa-icons/more_horiz.svg?svgr'
import MoreVertSvg from '@uswds/uswds/img/usa-icons/more_vert.svg?svgr'
import MyLocationSvg from '@uswds/uswds/img/usa-icons/my_location.svg?svgr'
import NavigateBeforeSvg from '@uswds/uswds/img/usa-icons/navigate_before.svg?svgr'
import NavigateNextSvg from '@uswds/uswds/img/usa-icons/navigate_next.svg?svgr'
import NavigateFarBeforeSvg from '@uswds/uswds/img/usa-icons/navigate_far_before.svg?svgr'
import NavigateFarNextSvg from '@uswds/uswds/img/usa-icons/navigate_far_next.svg?svgr'
import NearMeSvg from '@uswds/uswds/img/usa-icons/near_me.svg?svgr'
import NotificationsSvg from '@uswds/uswds/img/usa-icons/notifications.svg?svgr'
import NotificationsActiveSvg from '@uswds/uswds/img/usa-icons/notifications_active.svg?svgr'
import NotificationsNoneSvg from '@uswds/uswds/img/usa-icons/notifications_none.svg?svgr'
import NotificationsOffSvg from '@uswds/uswds/img/usa-icons/notifications_off.svg?svgr'
import ParkSvg from '@uswds/uswds/img/usa-icons/park.svg?svgr'
import PeopleSvg from '@uswds/uswds/img/usa-icons/people.svg?svgr'
import PersonSvg from '@uswds/uswds/img/usa-icons/person.svg?svgr'
import PetsSvg from '@uswds/uswds/img/usa-icons/pets.svg?svgr'
import PhoneSvg from '@uswds/uswds/img/usa-icons/phone.svg?svgr'
import PhotoCameraSvg from '@uswds/uswds/img/usa-icons/photo_camera.svg?svgr'
import PrintSvg from '@uswds/uswds/img/usa-icons/print.svg?svgr'
import PriorityHighSvg from '@uswds/uswds/img/usa-icons/priority_high.svg?svgr'
import PublicSvg from '@uswds/uswds/img/usa-icons/public.svg?svgr'
import PushPinSvg from '@uswds/uswds/img/usa-icons/push_pin.svg?svgr'
import RadioButtonUncheckedSvg from '@uswds/uswds/img/usa-icons/radio_button_unchecked.svg?svgr'
import RainSvg from '@uswds/uswds/img/usa-icons/rain.svg?svgr'
import ReduceCapacitySvg from '@uswds/uswds/img/usa-icons/reduce_capacity.svg?svgr'
import RemoveCircleSvg from '@uswds/uswds/img/usa-icons/remove_circle.svg?svgr'
import RemoveSvg from '@uswds/uswds/img/usa-icons/remove.svg?svgr'
import ReportSvg from '@uswds/uswds/img/usa-icons/report.svg?svgr'
import RestaurantSvg from '@uswds/uswds/img/usa-icons/restaurant.svg?svgr'
import RssFeedSvg from '@uswds/uswds/img/usa-icons/rss_feed.svg?svgr'
import SafetyDividerSvg from '@uswds/uswds/img/usa-icons/safety_divider.svg?svgr'
import SanitizerSvg from '@uswds/uswds/img/usa-icons/sanitizer.svg?svgr'
import SaveAltSvg from '@uswds/uswds/img/usa-icons/save_alt.svg?svgr'
import SevereWeatherSvg from '@uswds/uswds/img/usa-icons/severe_weather.svg?svgr'
import ScheduleSvg from '@uswds/uswds/img/usa-icons/schedule.svg?svgr'
import SchoolSvg from '@uswds/uswds/img/usa-icons/school.svg?svgr'
import ScienceSvg from '@uswds/uswds/img/usa-icons/science.svg?svgr'
import SearchSvg from '@uswds/uswds/img/usa-icons/search.svg?svgr'
import SecuritySvg from '@uswds/uswds/img/usa-icons/security.svg?svgr'
import SendSvg from '@uswds/uswds/img/usa-icons/send.svg?svgr'
import SentimentDissatisfiedSvg from '@uswds/uswds/img/usa-icons/sentiment_dissatisfied.svg?svgr'
import SentimentNeutralSvg from '@uswds/uswds/img/usa-icons/sentiment_neutral.svg?svgr'
import SentimentSatisfiedSvg from '@uswds/uswds/img/usa-icons/sentiment_satisfied.svg?svgr'
import SentimentSatisfiedAltSvg from '@uswds/uswds/img/usa-icons/sentiment_satisfied_alt.svg?svgr'
import SentimentVeryDissatisfiedSvg from '@uswds/uswds/img/usa-icons/sentiment_very_dissatisfied.svg?svgr'
import SettingsSvg from '@uswds/uswds/img/usa-icons/settings.svg?svgr'
import ShareSvg from '@uswds/uswds/img/usa-icons/share.svg?svgr'
import ShieldSvg from '@uswds/uswds/img/usa-icons/shield.svg?svgr'
import ShoppingBasketSvg from '@uswds/uswds/img/usa-icons/shopping_basket.svg?svgr'
import SnowSvg from '@uswds/uswds/img/usa-icons/snow.svg?svgr'
import SoapSvg from '@uswds/uswds/img/usa-icons/soap.svg?svgr'
import SocialDistanceSvg from '@uswds/uswds/img/usa-icons/social_distance.svg?svgr'
import SortArrowSvg from '@uswds/uswds/img/usa-icons/sort_arrow.svg?svgr'
import SpellcheckSvg from '@uswds/uswds/img/usa-icons/spellcheck.svg?svgr'
import StarSvg from '@uswds/uswds/img/usa-icons/star.svg?svgr'
import StarHalfSvg from '@uswds/uswds/img/usa-icons/star_half.svg?svgr'
import StarOutlineSvg from '@uswds/uswds/img/usa-icons/star_outline.svg?svgr'
import StoreSvg from '@uswds/uswds/img/usa-icons/store.svg?svgr'
import SupportSvg from '@uswds/uswds/img/usa-icons/support.svg?svgr'
import SupportAgentSvg from '@uswds/uswds/img/usa-icons/support_agent.svg?svgr'
import TextFieldsSvg from '@uswds/uswds/img/usa-icons/text_fields.svg?svgr'
import ThumbDownAltSvg from '@uswds/uswds/img/usa-icons/thumb_down_alt.svg?svgr'
import ThumbUpAltSvg from '@uswds/uswds/img/usa-icons/thumb_up_alt.svg?svgr'
import TimerSvg from '@uswds/uswds/img/usa-icons/timer.svg?svgr'
import ToggleOffSvg from '@uswds/uswds/img/usa-icons/toggle_off.svg?svgr'
import ToggleOnSvg from '@uswds/uswds/img/usa-icons/toggle_on.svg?svgr'
import TopicSvg from '@uswds/uswds/img/usa-icons/topic.svg?svgr'
import TornadoSvg from '@uswds/uswds/img/usa-icons/tornado.svg?svgr'
import TranslateSvg from '@uswds/uswds/img/usa-icons/translate.svg?svgr'
import TrendingDownSvg from '@uswds/uswds/img/usa-icons/trending_down.svg?svgr'
import TrendingUpSvg from '@uswds/uswds/img/usa-icons/trending_up.svg?svgr'
import TwitterSvg from '@uswds/uswds/img/usa-icons/twitter.svg?svgr'
import UndoSvg from '@uswds/uswds/img/usa-icons/undo.svg?svgr'
import UnfoldLessSvg from '@uswds/uswds/img/usa-icons/unfold_less.svg?svgr'
import UnfoldMoreSvg from '@uswds/uswds/img/usa-icons/unfold_more.svg?svgr'
import UpdateSvg from '@uswds/uswds/img/usa-icons/update.svg?svgr'
import UploadFileSvg from '@uswds/uswds/img/usa-icons/upload_file.svg?svgr'
import VerifiedSvg from '@uswds/uswds/img/usa-icons/verified.svg?svgr'
import VerifiedUserSvg from '@uswds/uswds/img/usa-icons/verified_user.svg?svgr'
import VisibilitySvg from '@uswds/uswds/img/usa-icons/visibility.svg?svgr'
import VisibilityOffSvg from '@uswds/uswds/img/usa-icons/visibility_off.svg?svgr'
import VolumeOffSvg from '@uswds/uswds/img/usa-icons/volume_off.svg?svgr'
import WarningSvg from '@uswds/uswds/img/usa-icons/warning.svg?svgr'
import WashSvg from '@uswds/uswds/img/usa-icons/wash.svg?svgr'
import WifiSvg from '@uswds/uswds/img/usa-icons/wifi.svg?svgr'
import WorkSvg from '@uswds/uswds/img/usa-icons/work.svg?svgr'
import XSvg from '@uswds/uswds/img/usa-icons/x.svg?svgr'
import YoutubeSvg from '@uswds/uswds/img/usa-icons/youtube.svg?svgr'
import ZoomInSvg from '@uswds/uswds/img/usa-icons/zoom_in.svg?svgr'
import ZoomOutMapSvg from '@uswds/uswds/img/usa-icons/zoom_out_map.svg?svgr'
import ZoomOutSvg from '@uswds/uswds/img/usa-icons/zoom_out.svg?svgr'

import { makeUSWDSIcon, IconProps } from './Icon'
import React from 'react'

export class Icon {
  public static AccessibilityNew: React.ComponentType<IconProps> =
    makeUSWDSIcon(AccessibilityNewSvg)

  public static AccessibleForward: React.ComponentType<IconProps> =
    makeUSWDSIcon(AccessibleForwardSvg)

  public static AccountBalance: React.ComponentType<IconProps> =
    makeUSWDSIcon(AccountBalanceSvg)

  public static AccountBox: React.ComponentType<IconProps> =
    makeUSWDSIcon(AccountBoxSvg)

  public static AccountCircle: React.ComponentType<IconProps> =
    makeUSWDSIcon(AccountCircleSvg)

  public static Add: React.ComponentType<IconProps> = makeUSWDSIcon(AddSvg)

  public static AddCircle: React.ComponentType<IconProps> =
    makeUSWDSIcon(AddCircleSvg)

  public static AddCircleOutline: React.ComponentType<IconProps> =
    makeUSWDSIcon(AddCircleOutlineSvg)

  public static Alarm: React.ComponentType<IconProps> = makeUSWDSIcon(AlarmSvg)

  public static AlternateEmail: React.ComponentType<IconProps> =
    makeUSWDSIcon(AlternateEmailSvg)

  public static Announcement: React.ComponentType<IconProps> =
    makeUSWDSIcon(AnnouncementSvg)

  public static ArrowBack: React.ComponentType<IconProps> =
    makeUSWDSIcon(ArrowBackSvg)

  public static ArrowDownward: React.ComponentType<IconProps> =
    makeUSWDSIcon(ArrowDownwardSvg)

  public static ArrowDropDown: React.ComponentType<IconProps> =
    makeUSWDSIcon(ArrowDropDownSvg)

  public static ArrowDropUp: React.ComponentType<IconProps> =
    makeUSWDSIcon(ArrowDropUpSvg)

  public static ArrowForward: React.ComponentType<IconProps> =
    makeUSWDSIcon(ArrowForwardSvg)

  public static ArrowUpward: React.ComponentType<IconProps> =
    makeUSWDSIcon(ArrowUpwardSvg)

  public static Api: React.ComponentType<IconProps> = makeUSWDSIcon(ApiSvg)

  public static Assessment: React.ComponentType<IconProps> =
    makeUSWDSIcon(AssessmentSvg)

  public static AttachFile: React.ComponentType<IconProps> =
    makeUSWDSIcon(AttachFileSvg)

  public static AttachMoney: React.ComponentType<IconProps> =
    makeUSWDSIcon(AttachMoneySvg)

  public static Autorenew: React.ComponentType<IconProps> =
    makeUSWDSIcon(AutorenewSvg)

  public static Backpack: React.ComponentType<IconProps> =
    makeUSWDSIcon(BackpackSvg)

  public static Bathtub: React.ComponentType<IconProps> =
    makeUSWDSIcon(BathtubSvg)

  public static Bedding: React.ComponentType<IconProps> =
    makeUSWDSIcon(BeddingSvg)

  public static Bookmark: React.ComponentType<IconProps> =
    makeUSWDSIcon(BookmarkSvg)

  public static BugReport: React.ComponentType<IconProps> =
    makeUSWDSIcon(BugReportSvg)

  public static Build: React.ComponentType<IconProps> = makeUSWDSIcon(BuildSvg)

  public static CalendarToday: React.ComponentType<IconProps> =
    makeUSWDSIcon(CalendarTodaySvg)

  public static Campaign: React.ComponentType<IconProps> =
    makeUSWDSIcon(CampaignSvg)

  public static Camping: React.ComponentType<IconProps> =
    makeUSWDSIcon(CampingSvg)

  public static Cancel: React.ComponentType<IconProps> =
    makeUSWDSIcon(CancelSvg)

  public static Chat: React.ComponentType<IconProps> = makeUSWDSIcon(ChatSvg)

  public static Check: React.ComponentType<IconProps> = makeUSWDSIcon(CheckSvg)

  public static CheckBoxOutlineBlank: React.ComponentType<IconProps> =
    makeUSWDSIcon(CheckBoxOutlineBlankSvg)

  public static CheckCircle: React.ComponentType<IconProps> =
    makeUSWDSIcon(CheckCircleSvg)

  public static CheckCircleOutline: React.ComponentType<IconProps> =
    makeUSWDSIcon(CheckCircleOutlineSvg)

  public static Checkroom: React.ComponentType<IconProps> =
    makeUSWDSIcon(CheckroomSvg)

  public static CleanHands: React.ComponentType<IconProps> =
    makeUSWDSIcon(CleanHandsSvg)

  public static Clothes: React.ComponentType<IconProps> =
    makeUSWDSIcon(ClothesSvg)

  public static Close: React.ComponentType<IconProps> = makeUSWDSIcon(CloseSvg)

  public static ClosedCaption: React.ComponentType<IconProps> =
    makeUSWDSIcon(ClosedCaptionSvg)

  public static Cloud: React.ComponentType<IconProps> = makeUSWDSIcon(CloudSvg)

  public static Code: React.ComponentType<IconProps> = makeUSWDSIcon(CodeSvg)

  public static Comment: React.ComponentType<IconProps> =
    makeUSWDSIcon(CommentSvg)

  public static ConnectWithoutContact: React.ComponentType<IconProps> =
    makeUSWDSIcon(ConnectWithoutContactSvg)

  public static Construction: React.ComponentType<IconProps> =
    makeUSWDSIcon(ConstructionSvg)

  public static ConstructionWorker: React.ComponentType<IconProps> =
    makeUSWDSIcon(ConstructionWorkerSvg)

  public static ContactPage: React.ComponentType<IconProps> =
    makeUSWDSIcon(ContactPageSvg)

  public static ContentCopy: React.ComponentType<IconProps> =
    makeUSWDSIcon(ContentCopySvg)

  public static Coronavirus: React.ComponentType<IconProps> =
    makeUSWDSIcon(CoronavirusSvg)

  public static CreditCard: React.ComponentType<IconProps> =
    makeUSWDSIcon(CreditCardSvg)

  public static Deck: React.ComponentType<IconProps> = makeUSWDSIcon(DeckSvg)

  public static Delete: React.ComponentType<IconProps> =
    makeUSWDSIcon(DeleteSvg)

  public static DeviceThermostat: React.ComponentType<IconProps> =
    makeUSWDSIcon(DeviceThermostatSvg)

  public static Directions: React.ComponentType<IconProps> =
    makeUSWDSIcon(DirectionsSvg)

  public static DirectionsBike: React.ComponentType<IconProps> =
    makeUSWDSIcon(DirectionsBikeSvg)

  public static DirectionsBus: React.ComponentType<IconProps> =
    makeUSWDSIcon(DirectionsBusSvg)

  public static DirectionsCar: React.ComponentType<IconProps> =
    makeUSWDSIcon(DirectionsCarSvg)

  public static DirectionsWalk: React.ComponentType<IconProps> =
    makeUSWDSIcon(DirectionsWalkSvg)

  public static DoNotDisturb: React.ComponentType<IconProps> =
    makeUSWDSIcon(DoNotDisturbSvg)

  public static DoNotTouch: React.ComponentType<IconProps> =
    makeUSWDSIcon(DoNotTouchSvg)

  public static DragHandle: React.ComponentType<IconProps> =
    makeUSWDSIcon(DragHandleSvg)

  public static Eco: React.ComponentType<IconProps> = makeUSWDSIcon(EcoSvg)

  public static Edit: React.ComponentType<IconProps> = makeUSWDSIcon(EditSvg)

  public static ElectricalServices: React.ComponentType<IconProps> =
    makeUSWDSIcon(ElectricalServicesSvg)

  public static EmojiEvents: React.ComponentType<IconProps> =
    makeUSWDSIcon(EmojiEventsSvg)

  public static Error: React.ComponentType<IconProps> = makeUSWDSIcon(ErrorSvg)

  public static ErrorOutline: React.ComponentType<IconProps> =
    makeUSWDSIcon(ErrorOutlineSvg)

  public static Event: React.ComponentType<IconProps> = makeUSWDSIcon(EventSvg)

  public static ExpandLess: React.ComponentType<IconProps> =
    makeUSWDSIcon(ExpandLessSvg)

  public static ExpandMore: React.ComponentType<IconProps> =
    makeUSWDSIcon(ExpandMoreSvg)

  public static Facebook: React.ComponentType<IconProps> =
    makeUSWDSIcon(FacebookSvg)

  public static FastForward: React.ComponentType<IconProps> =
    makeUSWDSIcon(FastForwardSvg)

  public static FastRewind: React.ComponentType<IconProps> =
    makeUSWDSIcon(FastRewindSvg)

  public static Favorite: React.ComponentType<IconProps> =
    makeUSWDSIcon(FavoriteSvg)

  public static FavoriteBorder: React.ComponentType<IconProps> =
    makeUSWDSIcon(FavoriteBorderSvg)

  public static Fax: React.ComponentType<IconProps> = makeUSWDSIcon(FaxSvg)

  public static FileDownload: React.ComponentType<IconProps> =
    makeUSWDSIcon(FileDownloadSvg)

  public static FilePresent: React.ComponentType<IconProps> =
    makeUSWDSIcon(FilePresentSvg)

  public static FileUpload: React.ComponentType<IconProps> =
    makeUSWDSIcon(FileUploadSvg)

  public static FilterAlt: React.ComponentType<IconProps> =
    makeUSWDSIcon(FilterAltSvg)

  public static FilterList: React.ComponentType<IconProps> =
    makeUSWDSIcon(FilterListSvg)

  public static Fingerprint: React.ComponentType<IconProps> =
    makeUSWDSIcon(FingerprintSvg)

  public static FirstPage: React.ComponentType<IconProps> =
    makeUSWDSIcon(FirstPageSvg)

  public static Flag: React.ComponentType<IconProps> = makeUSWDSIcon(FlagSvg)

  public static Flickr: React.ComponentType<IconProps> =
    makeUSWDSIcon(FlickrSvg)

  public static Flight: React.ComponentType<IconProps> =
    makeUSWDSIcon(FlightSvg)

  public static Flooding: React.ComponentType<IconProps> =
    makeUSWDSIcon(FloodingSvg)

  public static Folder: React.ComponentType<IconProps> =
    makeUSWDSIcon(FolderSvg)

  public static FolderOpen: React.ComponentType<IconProps> =
    makeUSWDSIcon(FolderOpenSvg)

  public static FormatQuote: React.ComponentType<IconProps> =
    makeUSWDSIcon(FormatQuoteSvg)

  public static FormatSize: React.ComponentType<IconProps> =
    makeUSWDSIcon(FormatSizeSvg)

  public static Forum: React.ComponentType<IconProps> = makeUSWDSIcon(ForumSvg)

  public static Github: React.ComponentType<IconProps> =
    makeUSWDSIcon(GithubSvg)

  public static GridView: React.ComponentType<IconProps> =
    makeUSWDSIcon(GridViewSvg)

  public static GroupAdd: React.ComponentType<IconProps> =
    makeUSWDSIcon(GroupAddSvg)

  public static Groups: React.ComponentType<IconProps> =
    makeUSWDSIcon(GroupsSvg)

  public static Hearing: React.ComponentType<IconProps> =
    makeUSWDSIcon(HearingSvg)

  public static Help: React.ComponentType<IconProps> = makeUSWDSIcon(HelpSvg)

  public static HelpOutline: React.ComponentType<IconProps> =
    makeUSWDSIcon(HelpOutlineSvg)

  public static HighlightOff: React.ComponentType<IconProps> =
    makeUSWDSIcon(HighlightOffSvg)

  public static History: React.ComponentType<IconProps> =
    makeUSWDSIcon(HistorySvg)

  public static Home: React.ComponentType<IconProps> = makeUSWDSIcon(HomeSvg)

  public static Hospital: React.ComponentType<IconProps> =
    makeUSWDSIcon(HospitalSvg)

  public static Hotel: React.ComponentType<IconProps> = makeUSWDSIcon(HotelSvg)

  public static HourglassEmpty: React.ComponentType<IconProps> =
    makeUSWDSIcon(HourglassEmptySvg)

  public static Hurricane: React.ComponentType<IconProps> =
    makeUSWDSIcon(HurricaneSvg)

  public static Identification: React.ComponentType<IconProps> =
    makeUSWDSIcon(IdentificationSvg)

  public static Image: React.ComponentType<IconProps> = makeUSWDSIcon(ImageSvg)

  public static Info: React.ComponentType<IconProps> = makeUSWDSIcon(InfoSvg)

  public static InfoOutline: React.ComponentType<IconProps> =
    makeUSWDSIcon(InfoOutlineSvg)

  public static Insights: React.ComponentType<IconProps> =
    makeUSWDSIcon(InsightsSvg)

  public static Instagram: React.ComponentType<IconProps> =
    makeUSWDSIcon(InstagramSvg)

  public static Keyboard: React.ComponentType<IconProps> =
    makeUSWDSIcon(KeyboardSvg)

  public static Label: React.ComponentType<IconProps> = makeUSWDSIcon(LabelSvg)

  public static Language: React.ComponentType<IconProps> =
    makeUSWDSIcon(LanguageSvg)

  public static LastPage: React.ComponentType<IconProps> =
    makeUSWDSIcon(LastPageSvg)

  public static Launch: React.ComponentType<IconProps> =
    makeUSWDSIcon(LaunchSvg)

  public static Lightbulb: React.ComponentType<IconProps> =
    makeUSWDSIcon(LightbulbSvg)

  public static LightbulbOutline: React.ComponentType<IconProps> =
    makeUSWDSIcon(LightbulbOutlineSvg)

  public static LinkedIn: React.ComponentType<IconProps> =
    makeUSWDSIcon(LinkedInSvg)

  public static Link: React.ComponentType<IconProps> = makeUSWDSIcon(LinkSvg)

  public static LinkOff: React.ComponentType<IconProps> =
    makeUSWDSIcon(LinkOffSvg)

  public static List: React.ComponentType<IconProps> = makeUSWDSIcon(ListSvg)

  public static LocalCafe: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalCafeSvg)

  public static LocalFireDepartment: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalFireDepartmentSvg)

  public static LocalGasStation: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalGasStationSvg)

  public static LocalGroceryStore: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalGroceryStoreSvg)

  public static LocalHospital: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalHospitalSvg)

  public static LocalLaundryService: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalLaundryServiceSvg)

  public static LocalLibrary: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalLibrarySvg)

  public static LocalOffer: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalOfferSvg)

  public static LocalParking: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalParkingSvg)

  public static LocalPharmacy: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalPharmacySvg)

  public static LocalPolice: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalPoliceSvg)

  public static LocalTaxi: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocalTaxiSvg)

  public static LocationCity: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocationCitySvg)

  public static LocationOn: React.ComponentType<IconProps> =
    makeUSWDSIcon(LocationOnSvg)

  public static Lock: React.ComponentType<IconProps> = makeUSWDSIcon(LockSvg)

  public static LockOpen: React.ComponentType<IconProps> =
    makeUSWDSIcon(LockOpenSvg)

  public static LockOutline: React.ComponentType<IconProps> =
    makeUSWDSIcon(LockOutlineSvg)

  public static Login: React.ComponentType<IconProps> = makeUSWDSIcon(LoginSvg)

  public static Logout: React.ComponentType<IconProps> =
    makeUSWDSIcon(LogoutSvg)

  public static Loop: React.ComponentType<IconProps> = makeUSWDSIcon(LoopSvg)

  public static Mail: React.ComponentType<IconProps> = makeUSWDSIcon(MailSvg)

  public static MailOutline: React.ComponentType<IconProps> =
    makeUSWDSIcon(MailOutlineSvg)

  public static Map: React.ComponentType<IconProps> = makeUSWDSIcon(MapSvg)

  public static Masks: React.ComponentType<IconProps> = makeUSWDSIcon(MasksSvg)

  public static MedicalServices: React.ComponentType<IconProps> =
    makeUSWDSIcon(MedicalServicesSvg)

  public static Menu: React.ComponentType<IconProps> = makeUSWDSIcon(MenuSvg)

  public static MilitaryTech: React.ComponentType<IconProps> =
    makeUSWDSIcon(MilitaryTechSvg)

  public static MoreHoriz: React.ComponentType<IconProps> =
    makeUSWDSIcon(MoreHorizSvg)

  public static MoreVert: React.ComponentType<IconProps> =
    makeUSWDSIcon(MoreVertSvg)

  public static MyLocation: React.ComponentType<IconProps> =
    makeUSWDSIcon(MyLocationSvg)

  public static NavigateBefore: React.ComponentType<IconProps> =
    makeUSWDSIcon(NavigateBeforeSvg)

  public static NavigateNext: React.ComponentType<IconProps> =
    makeUSWDSIcon(NavigateNextSvg)

  public static NavigateFarBefore: React.ComponentType<IconProps> =
    makeUSWDSIcon(NavigateFarBeforeSvg)

  public static NavigateFarNext: React.ComponentType<IconProps> =
    makeUSWDSIcon(NavigateFarNextSvg)

  public static NearMe: React.ComponentType<IconProps> =
    makeUSWDSIcon(NearMeSvg)

  public static Notifications: React.ComponentType<IconProps> =
    makeUSWDSIcon(NotificationsSvg)

  public static NotificationsActive: React.ComponentType<IconProps> =
    makeUSWDSIcon(NotificationsActiveSvg)

  public static NotificationsNone: React.ComponentType<IconProps> =
    makeUSWDSIcon(NotificationsNoneSvg)

  public static NotificationsOff: React.ComponentType<IconProps> =
    makeUSWDSIcon(NotificationsOffSvg)

  public static Park: React.ComponentType<IconProps> = makeUSWDSIcon(ParkSvg)

  public static People: React.ComponentType<IconProps> =
    makeUSWDSIcon(PeopleSvg)

  public static Person: React.ComponentType<IconProps> =
    makeUSWDSIcon(PersonSvg)

  public static Pets: React.ComponentType<IconProps> = makeUSWDSIcon(PetsSvg)

  public static Phone: React.ComponentType<IconProps> = makeUSWDSIcon(PhoneSvg)

  public static PhotoCamera: React.ComponentType<IconProps> =
    makeUSWDSIcon(PhotoCameraSvg)

  public static Print: React.ComponentType<IconProps> = makeUSWDSIcon(PrintSvg)

  public static PriorityHigh: React.ComponentType<IconProps> =
    makeUSWDSIcon(PriorityHighSvg)

  public static Public: React.ComponentType<IconProps> =
    makeUSWDSIcon(PublicSvg)

  public static PushPin: React.ComponentType<IconProps> =
    makeUSWDSIcon(PushPinSvg)

  public static RadioButtonUnchecked: React.ComponentType<IconProps> =
    makeUSWDSIcon(RadioButtonUncheckedSvg)

  public static Rain: React.ComponentType<IconProps> = makeUSWDSIcon(RainSvg)

  public static ReduceCapacity: React.ComponentType<IconProps> =
    makeUSWDSIcon(ReduceCapacitySvg)

  public static RemoveCircle: React.ComponentType<IconProps> =
    makeUSWDSIcon(RemoveCircleSvg)

  public static Remove: React.ComponentType<IconProps> =
    makeUSWDSIcon(RemoveSvg)

  public static Report: React.ComponentType<IconProps> =
    makeUSWDSIcon(ReportSvg)

  public static Restaurant: React.ComponentType<IconProps> =
    makeUSWDSIcon(RestaurantSvg)

  public static RssFeed: React.ComponentType<IconProps> =
    makeUSWDSIcon(RssFeedSvg)

  public static SafetyDivider: React.ComponentType<IconProps> =
    makeUSWDSIcon(SafetyDividerSvg)

  public static Sanitizer: React.ComponentType<IconProps> =
    makeUSWDSIcon(SanitizerSvg)

  public static SaveAlt: React.ComponentType<IconProps> =
    makeUSWDSIcon(SaveAltSvg)

  public static SevereWeather: React.ComponentType<IconProps> =
    makeUSWDSIcon(SevereWeatherSvg)

  public static Schedule: React.ComponentType<IconProps> =
    makeUSWDSIcon(ScheduleSvg)

  public static School: React.ComponentType<IconProps> =
    makeUSWDSIcon(SchoolSvg)

  public static Science: React.ComponentType<IconProps> =
    makeUSWDSIcon(ScienceSvg)

  public static Search: React.ComponentType<IconProps> =
    makeUSWDSIcon(SearchSvg)

  public static Security: React.ComponentType<IconProps> =
    makeUSWDSIcon(SecuritySvg)

  public static Send: React.ComponentType<IconProps> = makeUSWDSIcon(SendSvg)

  public static SentimentDissatisfied: React.ComponentType<IconProps> =
    makeUSWDSIcon(SentimentDissatisfiedSvg)

  public static SentimentNeutral: React.ComponentType<IconProps> =
    makeUSWDSIcon(SentimentNeutralSvg)

  public static SentimentSatisfied: React.ComponentType<IconProps> =
    makeUSWDSIcon(SentimentSatisfiedSvg)

  public static SentimentSatisfiedAlt: React.ComponentType<IconProps> =
    makeUSWDSIcon(SentimentSatisfiedAltSvg)

  public static SentimentVeryDissatisfied: React.ComponentType<IconProps> =
    makeUSWDSIcon(SentimentVeryDissatisfiedSvg)

  public static Settings: React.ComponentType<IconProps> =
    makeUSWDSIcon(SettingsSvg)

  public static Share: React.ComponentType<IconProps> = makeUSWDSIcon(ShareSvg)

  public static Shield: React.ComponentType<IconProps> =
    makeUSWDSIcon(ShieldSvg)

  public static ShoppingBasket: React.ComponentType<IconProps> =
    makeUSWDSIcon(ShoppingBasketSvg)

  public static Snow: React.ComponentType<IconProps> = makeUSWDSIcon(SnowSvg)

  public static Soap: React.ComponentType<IconProps> = makeUSWDSIcon(SoapSvg)

  public static SocialDistance: React.ComponentType<IconProps> =
    makeUSWDSIcon(SocialDistanceSvg)

  public static SortArrow: React.ComponentType<IconProps> =
    makeUSWDSIcon(SortArrowSvg)

  public static Spellcheck: React.ComponentType<IconProps> =
    makeUSWDSIcon(SpellcheckSvg)

  public static Star: React.ComponentType<IconProps> = makeUSWDSIcon(StarSvg)

  public static StarHalf: React.ComponentType<IconProps> =
    makeUSWDSIcon(StarHalfSvg)

  public static StarOutline: React.ComponentType<IconProps> =
    makeUSWDSIcon(StarOutlineSvg)

  public static Store: React.ComponentType<IconProps> = makeUSWDSIcon(StoreSvg)

  public static Support: React.ComponentType<IconProps> =
    makeUSWDSIcon(SupportSvg)

  public static SupportAgent: React.ComponentType<IconProps> =
    makeUSWDSIcon(SupportAgentSvg)

  public static TextFields: React.ComponentType<IconProps> =
    makeUSWDSIcon(TextFieldsSvg)

  public static ThumbDownAlt: React.ComponentType<IconProps> =
    makeUSWDSIcon(ThumbDownAltSvg)

  public static ThumbUpAlt: React.ComponentType<IconProps> =
    makeUSWDSIcon(ThumbUpAltSvg)

  public static Timer: React.ComponentType<IconProps> = makeUSWDSIcon(TimerSvg)

  public static ToggleOff: React.ComponentType<IconProps> =
    makeUSWDSIcon(ToggleOffSvg)

  public static ToggleOn: React.ComponentType<IconProps> =
    makeUSWDSIcon(ToggleOnSvg)

  public static Topic: React.ComponentType<IconProps> = makeUSWDSIcon(TopicSvg)

  public static Tornado: React.ComponentType<IconProps> =
    makeUSWDSIcon(TornadoSvg)

  public static Translate: React.ComponentType<IconProps> =
    makeUSWDSIcon(TranslateSvg)

  public static TrendingDown: React.ComponentType<IconProps> =
    makeUSWDSIcon(TrendingDownSvg)

  public static TrendingUp: React.ComponentType<IconProps> =
    makeUSWDSIcon(TrendingUpSvg)

  public static Twitter: React.ComponentType<IconProps> =
    makeUSWDSIcon(TwitterSvg)

  public static Undo: React.ComponentType<IconProps> = makeUSWDSIcon(UndoSvg)

  public static UnfoldLess: React.ComponentType<IconProps> =
    makeUSWDSIcon(UnfoldLessSvg)

  public static UnfoldMore: React.ComponentType<IconProps> =
    makeUSWDSIcon(UnfoldMoreSvg)

  public static Update: React.ComponentType<IconProps> =
    makeUSWDSIcon(UpdateSvg)

  public static UploadFile: React.ComponentType<IconProps> =
    makeUSWDSIcon(UploadFileSvg)

  public static Verified: React.ComponentType<IconProps> =
    makeUSWDSIcon(VerifiedSvg)

  public static VerifiedUser: React.ComponentType<IconProps> =
    makeUSWDSIcon(VerifiedUserSvg)

  public static Visibility: React.ComponentType<IconProps> =
    makeUSWDSIcon(VisibilitySvg)

  public static VisibilityOff: React.ComponentType<IconProps> =
    makeUSWDSIcon(VisibilityOffSvg)

  public static VolumeOff: React.ComponentType<IconProps> =
    makeUSWDSIcon(VolumeOffSvg)

  public static Warning: React.ComponentType<IconProps> =
    makeUSWDSIcon(WarningSvg)

  public static Wash: React.ComponentType<IconProps> = makeUSWDSIcon(WashSvg)

  public static Wifi: React.ComponentType<IconProps> = makeUSWDSIcon(WifiSvg)

  public static Work: React.ComponentType<IconProps> = makeUSWDSIcon(WorkSvg)

  public static X: React.ComponentType<IconProps> = makeUSWDSIcon(XSvg)

  public static Youtube: React.ComponentType<IconProps> =
    makeUSWDSIcon(YoutubeSvg)

  public static ZoomIn: React.ComponentType<IconProps> =
    makeUSWDSIcon(ZoomInSvg)

  public static ZoomOutMap: React.ComponentType<IconProps> =
    makeUSWDSIcon(ZoomOutMapSvg)

  public static ZoomOut: React.ComponentType<IconProps> =
    makeUSWDSIcon(ZoomOutSvg)
}

export default Icon
